module.exports = __webpack_public_path__ + "static/media/dotloader.df5b3d16.gif";